import { CartCharges, CartItem, CartSelectedCustomization } from "../order-cart.model";

export interface WirelessCartData {
    monthly?: WirelessCartLineData[];
    totalMonthlyAmount?: number;
    firstBillCharges?: CartCharges;
    todaysCharges?: CartCharges;
    savingAndPromotionCharges?: CartCharges;
    packagesCharges?: CartCharges;
}

export interface WirelessCartLineData {
    lineNumber?: number;
    device?: CartItem;
    charges?: CartCharges;
    promotions?: CartCharges;
    tradeIn?: WirelessCartTradeIn | null;
    totalAmount?: number;
}

export interface WirelessCartTradeIn {
    model: string;
    tradeInValue: number;
    promoDiscount: number;
    financingMonths: number;
    monthlyCredit: number;
}

export enum WirelessCartCustomizationType {
    Line = 'Line',
    OrderQualification = 'OrderQualification',
    Global = 'Global'
}

export enum LineConfigType {
    Device = 'Device',
    Plan = 'Plan',
    Installment = 'Installment',
    Protection = 'Protection',
    Promotion = 'Promotion',
    Offers = 'Offers'
}

export interface WirelessCartSelectedCustomization extends CartSelectedCustomization {
    lineNumber?: number;
    type: WirelessCartCustomizationType;
    lineType?: LineConfigType;
}
